import type { ExternalRepository } from '../../types';

export const isExternalRepository = (entity: any): entity is ExternalRepository =>
	entity.__typename === 'ExternalRepository';

export const getExternalRepositoryLink = (repository: ExternalRepository): string | null =>
	repository?.repositoryUrl ?? null;
